import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';
import { useCart } from '@/hooks/useCart';

const featured = products.slice(0, 4);

export default function FeaturedProducts() {
  const { addItem } = useCart();

  return (
    <section className="w-full bg-[#faf8f5] py-24 px-6 md:px-16">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-14 gap-4">
        <div>
          <p className="text-xs uppercase tracking-[0.3em] text-[#8B6348] mb-3 font-medium">Curated for You</p>
          <h2 className="text-4xl md:text-5xl font-bold text-[#2c2420]" style={{ fontFamily: "'Playfair Display', serif" }}>
            Featured Pieces
          </h2>
        </div>
        <Link
          to="/products"
          className="whitespace-nowrap text-sm text-[#3a3228] font-medium flex items-center gap-2 hover:text-[#8B6348] transition-colors cursor-pointer group"
        >
          View All Products
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
          </span>
        </Link>
      </div>

      {/* Product Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {featured.map((product) => (
          <article
            key={product.id}
            className="bg-white rounded-2xl overflow-hidden group cursor-pointer"
          >
            <div className="relative overflow-hidden w-full h-[280px]">
              <img
                src={product.image}
                alt={product.name}
                title={`${product.name} - premium furniture`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {product.tag && (
                <span className="absolute top-3 left-3 bg-[#3a3228] text-white text-[10px] font-medium uppercase tracking-wider px-2.5 py-1 rounded-full">
                  {product.tag}
                </span>
              )}
              {/* Add to Cart overlay */}
              <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    addItem({
                      id: product.id,
                      name: product.name,
                      price: product.price,
                      image: product.image,
                      category: product.category,
                    });
                  }}
                  className="whitespace-nowrap w-full py-3.5 bg-[#2c2420] text-white text-xs font-semibold uppercase tracking-widest hover:bg-[#8B6348] transition-colors cursor-pointer flex items-center justify-center gap-2"
                >
                  <i className="ri-shopping-bag-line" />
                  Add to Cart
                </button>
              </div>
            </div>
            <div className="p-5">
              <p className="text-[10px] uppercase tracking-widest text-stone-400 mb-1">{product.category}</p>
              <h3 className="text-[#2c2420] font-semibold text-base mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>
                {product.name}
              </h3>
              <div className="flex items-center justify-between">
                <p className="text-[#8B6348] font-semibold text-base">${product.price.toLocaleString()}</p>
                <button
                  onClick={() =>
                    addItem({
                      id: product.id,
                      name: product.name,
                      price: product.price,
                      image: product.image,
                      category: product.category,
                    })
                  }
                  className="whitespace-nowrap w-8 h-8 flex items-center justify-center rounded-full bg-[#f5f0ea] text-[#8B6348] hover:bg-[#8B6348] hover:text-white transition-all duration-200 cursor-pointer"
                  title="Add to Cart"
                >
                  <i className="ri-add-line text-base" />
                </button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
